export const ACTION = {
    GET_STATIC_PAGE_CONTENT: 'GET_STATIC_PAGE_CONTENT',
};

